module.exports = __webpack_public_path__ + "static/media/components.d1763a31.svg";